import { useTranslation } from 'react-i18next';
import React, {useState, useEffect, Fragment} from 'react';
import { useParams } from "react-router-dom";
import apiRequest from '../../functions/api';
import {TextField, Typography,Container,Table, Hidden, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Button,  Box, } from "@mui/material";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import Grid from '@mui/material/Grid'
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
function EntgeltantragPersonal(props) {
  const { t } = useTranslation();
    // Standard Variablen
        const {client, accessToken} = props;
        const { antragid } = useParams();
        const {showErrorMessage} = useMessage();
        const [isLoading, setIsLoading] = useState(false);
        const [open,setOpen]=useState(-1);
    
    // Arbeitsvariablen
        const [zeilen,setZeilen]=useState([]);
        
    
    // Functions
        useEffect(() => {
            setIsLoading(true);
            if (antragid.substr(21,1)==="1"){
                const payload={
                    "mandant": client,
                    "program": "PMURA3",
                    "statement": "ANTRAG_PERSONAL",
                    "key": antragid,
                }
                const headers={
                    "Authorization": "Bearer "+accessToken,
                }
                apiRequest('POST', 'daten', payload, headers, postLaden);
            } else {
                const payload={
                    "mandant": client,
                    "program": "FORANT",
                    "statement": "ANTRAG_PERSONAL",
                    "key": antragid,
                }
                const headers={
                    "Authorization": "Bearer "+accessToken,
                }
                apiRequest('POST', 'daten', payload, headers, postLaden);
            }
            // eslint-disable-next-line
        }, []);
        const postLaden=(response)=>{
            setIsLoading(false);
            
            if (response.status === 200) {
                setZeilen(response.data.zeilen)
            } else {
                if (response) {
                    showErrorMessage(response.data.message);
                } else {
                    showErrorMessage(t("Keine Internetverbindung"));
                }
            }
        }
        function Abbrechen(){
            setOpen(-1);
        }
        function onClick(index){
            setOpen(index);
            console.log(open)
        }
        if (isLoading) {
            return <LoadingComponent />
        }
    //Anzeige
        function tableHeader(){
            return (
                <TableRow>
                    <TableCell align="center" className="tabledesign">{t("Zeitraum")}</TableCell>
                    <TableCell align="center" className="tabledesign">{t("Eingabe")}</TableCell>
                    <Hidden lgDown>
                        <TableCell align="center" className="tabledesign">{t("Wert alt")}</TableCell>
                    </Hidden>
                    <Hidden lgDown>
                        <TableCell align="center" className="tabledesign">{t("Wert neu")}</TableCell>
                    </Hidden>
                    <Hidden lgDown>
                        <TableCell align="center" className="tabledesign">{t("Kommentar")}</TableCell>
                    </Hidden>
                    <Hidden lgUp>
                        <TableCell align="center" className="tabledesign"><EditIcon/></TableCell>
                    </Hidden>
                </TableRow>
            );
        }
        function tableBody(){
            return(
                <Fragment>
                {(zeilen&&zeilen.length>0)&&zeilen.map((item,index)=>(
       
                    <TableRow key={"zeile"+index} >
                        <TableCell align="center" className="tabledesign">
                            <Container>
                            <Typography
                                component="div"
                            >{item.zr}</Typography >
                            </Container>
                        </TableCell>
                        <TableCell align="center" className="tabledesign">
                            <Container>
                            <Typography
                                component="div"
                            >{item.feld}</Typography>
                            </Container>
                        </TableCell>
                        <Hidden lgDown>
                        <TableCell align="center" className="tabledesign">
                            <Container>
                            <Typography
                                component="div"
                            >{item.alt}</Typography>
                            </Container>
                        </TableCell>
                        </Hidden>
                        <Hidden lgDown>
                        <TableCell align="center" className="tabledesign">
                            <Container>
                            <Typography
                                component="div"
                            >{item.neu}</Typography>
                            </Container>
                        </TableCell>
                        </Hidden>
                        <Hidden lgDown>
                        <TableCell align="center" className="tabledesign">
                            <Container>
                            <Typography
                                component="div"
                            >{item.grund}</Typography>
                            </Container>
                        </TableCell>
                        </Hidden>
                        <Hidden lgUp>
                        <TableCell align="center" className="tabledesign">
                            <IconButton color="primary" onClick={()=>onClick(index)}>
                                <VisibilityIcon/>
                            </IconButton>
                        </TableCell>
                        </Hidden>
                    </TableRow>
                    
                ))}
                </Fragment>
            );
            
        }
    
        return(
            <Fragment>
                {(zeilen&&zeilen.length>0&&open!==-1)&&<ResponsiveDialog 
                    title={t("Änderungen der Personalabteilung")}
                    open={(open!==-1)} 
                    setOpen={() => setOpen(-1)}
                    actionButton={
                        <Fragment>
                        <Button color="primary" onClick={() => Abbrechen()}>{t("Zurück")}</Button>
                        </Fragment>
                    }
                >   
                <Box padding={2}>
                <Grid container spacing={2} justifyContent="center" >
                    <Grid item xs={12}>
                    <TextField
                        id="zeitraum"
                        label={t("Zeitraum")}
                        fullWidth
                        disabled
                        value={zeilen[open].zr}
                        variant="outlined"
                    />
                    </Grid>
                    <Grid item xs={12}>
                    <TextField
                        id="eingabe"
                        label={t("Eingabe")}
                        fullWidth
                        disabled
                        value={zeilen[open].feld}
                        variant="outlined"
                    />
                    </Grid>
       
                    <Grid item xs={12}>
                    <TextField
                        id="alt"
                        label={t("Wert alt")}
                        fullWidth
                        disabled
                        value={zeilen[open].alt}
                        variant="outlined"
                    />
                    </Grid>
           
                    <Grid item xs={12} >
                    <TextField
                        id="neu"
                        label={t("Wert neu")}
                        fullWidth
                        disabled
                        value={zeilen[open].neu}
                        variant="outlined"
                    />
                    </Grid>
                    <Grid item xs={12} >
                    <TextField
                        id="grund"
                        label={t("Kommentar")}
                        fullWidth
                        disabled
                        value={zeilen[open].grund}
                        variant="outlined"
                    
                    />
                    </Grid>
                    </Grid>
                    </Box>
                </ResponsiveDialog>}
                <Grid container justifyContent="center" spacing={1} >
                <Grid item xs={12}>
                <Typography>{t("Änderungen der Personalabteilung")}</Typography>   
                </Grid>
                <Grid item xs={12} md={8} >
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                {tableHeader()}
                            </TableHead>
                            <TableBody>
                                {tableBody()}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                </Grid>
            </Fragment>
        )
    }
    export default EntgeltantragPersonal;
